import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateDialog } from '../../ui/action-creators';
import store from '../../index';
import * as tracPage from '@webapp/sdk/tracpage';
import { DeleteTracLink, DeleteTracLinkError } from '../action-creators';
import { DELETE_TRAC_LINK } from '../actions';
import AppState from '../../state';
import { DeleteTracLinkSuccess } from '../action-creators';

export const deleteTracLinkEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, DeleteTracLink>(DELETE_TRAC_LINK),
    withLatestFrom(state$),
    map(([action, state]) => {
      return new CreateDialog(`TRACLINK_DELETE.${action.tracLinkId}`, {
        open: true,
        title: `Confirm Delete`,
        text: `Are you sure you want to Delete ${action.title}? This can't be undone.`,
        actions: [
          { type: 'primary', label: 'No', value: false },
          { type: 'secondary', label: 'Yes', value: true },
        ],
        callback: async (result) => {
          if (result) {
            try {
              await tracPage.removeTracLink(
                state.artist.active?.id as string,
                action.tracLinkId
              );

              return store.dispatch(
                new DeleteTracLinkSuccess(action.tracLinkId)
              );
            } catch (err) {
              return store.dispatch(new DeleteTracLinkError(err.message));
            }
          }
        },
      });
    })
  );
